import { isObject } from 'lodash';
import { enumTranslator, isEmpty } from '../../../utils';
import { api } from '../../../fetch/bussiness/api';
import { request } from '@/fetch/core';
import { HttpStatusCode } from '../../../fetch/core/constant';

//获取实时信息
const getVehicleStatus = async (vehicleName?: string, date?: string) => {
  const requestBody = {
    vehicleName: vehicleName,
    date: date,
  };
  const queryData: any = {
    method: 'POST',
    path: api.getVehicleRealtimeInfo,
    body: requestBody,
  };
  return await request(queryData);
};
//deprecated 不再使用，由服务端进行拼装描述信息，逻辑结构暂保留
const getParams = (
  values: { [key: string]: any },
  vehicle?: string,
  stationName?: string,
  vehicleRealtimeInfo?: {
    systemState: string;
    vehicleState: string;
  }
) => {
  const store = (window as any).store;
  let state = store.getState();
  state = {
    ...state.common,
    login: state.login,
    singleVehiclePageInfo: state.singleVehiclePageInfo,
  };
  const username =
    state && state.login && state.login.user && state.login.user.username;
  const vehicleBasicInfoNew = state.singleVehiclePageInfo.vehicleBasicInfoNew;

  const description = () => {
    let systemStateCode = vehicleRealtimeInfo?.systemState;
    let vehicleStateCode = vehicleRealtimeInfo?.vehicleState;

    const name = username ? `[提报人]：${username}` : null;
    const systemStateName = systemStateCode
      ? enumTranslator('SYSTEM_STATE_ENUM', systemStateCode)
      : '--'; // 系统状态
    const vehicleStateName = vehicleStateCode
      ? enumTranslator('VEHICLE_STATE_ENUM', vehicleStateCode)
      : '--'; // 车辆模式
    const vehicleState = vehicleStateName
      ? `[车辆模式]:${vehicleStateName}`
      : null;
    const systemState = systemStateName
      ? `[系统状态]:${systemStateName}`
      : null;

    const des = [];
    if (typeof name == 'string') {
      des.push(name);
    }
    if (typeof vehicleState == 'string') {
      des.push(vehicleState);
    }
    if (typeof systemState == 'string') {
      des.push(systemState);
    }
    const desList = [
      ...des,
      `[详情描述]:【${stationName ?? vehicleBasicInfoNew.stationName}】 ${
        values.description
      }`,
    ];
    const desc = desList.toString();
    return desc;
  };
  const params = {
    topic: values.topic,
    description: description(),
    accidentLevel: values?.accidentLevel ?? null,
    accidentType: values?.accidentType ?? null,
    severity: isObject(values.severity)
      ? values.severity?.value
      : values?.severity,
    version: values.version,
    debugTime: values.debugTime,
    vehicleName: vehicle ?? '',
    follower: values.follower,
    attachment: !isEmpty(values?.attachment) ? values.attachment : null,
  };
  return params;
};

export const formatJiraSubmit = (
  values: { [key: string]: any },
  vehicle?: string,
  stationName?: string
) => {
  return {
    topic: values.topic,
    description: values.description,
    technicalSupportResponsible: values?.technicalSupportResponsible ?? null,
    accidentLevel: values?.accidentLevel ?? null,
    accidentType: values?.accidentType ?? null,
    severity: isObject(values.severity)
      ? values.severity?.value
      : values?.severity,
    version: values.version,
    debugTime: values.debugTime,
    vehicleName: vehicle ?? '',
    follower: values.follower,
    attachment: !isEmpty(values?.attachment) ? values.attachment : null,
  };
};
